<template>
  <div class="content" v-if="selectedShop">
    <div
      class="top-image"
      :style="{
        backgroundImage: `url('${selectedShop.site.topImage.imageUri}')`
      }"
    >
      <div class="close-button" @click="closeClicked">
        <v-ons-icon icon="fa-times"></v-ons-icon>
      </div>
    </div>

    <div class="wrapper">
      <h1 class="shop-name">{{ selectedShop.nameKanji }}</h1>
      <small class="shop-category">
        {{ selectedShop.site.genre.genre }}
      </small>

      <div class="data-row">
        <img :src="location" />
        <div>{{ selectedShop.address }}</div>
      </div>

      <div class="data-row">
        <img :src="openingTime" />
        <div>
          <opening-hours
            :startTime="selectedShop.startTime"
            :endTime="selectedShop.endTime"
            :holiday="selectedShop.holiday"
          ></opening-hours>
        </div>
      </div>

      <div>
        <a :href="'tel:' + selectedShop.phoneNumber" class="data-row">
          <img :src="phone" />
          <div style="flex: 1">
            {{ selectedShop.phoneNumber }}
          </div>
          <img :src="discloseIndicator" />
        </a>
      </div>

      <div v-if="selectedShop.site.websiteUrl">
        <a :href="selectedShop.site.websiteUrl" class="data-row">
          <img :src="website" />
          <div style="flex: 1">
            公式サイト
          </div>
          <img :src="discloseIndicator" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import OpeningHours from "./OpeningHours"
import DiscloseIndicator from "../assets/disclosure-indicator.svg"
import Location from "../assets/location.svg"
import OpeningTime from "../assets/opening-time.svg"
import Phone from "../assets/phone.svg"
import Website from "../assets/website.svg"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      discloseIndicator: DiscloseIndicator,
      location: Location,
      openingTime: OpeningTime,
      phone: Phone,
      website: Website
    }
  },

  methods: {
    closeClicked() {
      this.setSelectedShopId(null)
    },

    ...mapActions("stores", ["setSelectedShopId"])
  },

  computed: {
    ...mapGetters("stores", ["selectedShopId", "selectedShop"])
  },

  watch: {
    selectedShopId() {
      if (
        this.selectedShopId !== null &&
        (!this.selectedShop || this.selectedShopId !== this.selectedShop.id)
      ) {
        this.$log.warn("Stale data detected, TODO: implement refresh")
      }
    }
  },

  components: {
    OpeningHours
  }
}
</script>

<style>
.data-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1rem 0;
}

a.data-row {
  color: #000;
  text-decoration: none;
}

.data-row img:not(:last-child) {
  margin-right: 0.5rem;
}

.top-image {
  width: 100%;
  min-height: 14rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.close-button {
  position: fixed;
  top: 1rem;
  right: 1rem;
  width: 2.5rem;
  height: 2.5rem;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #707070;
  border-radius: 0.5rem;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.161);
}

.wrapper {
  box-sizing: border-box;
  width: 100%;
  padding: 1.75rem 1.25rem;
}

h1.shop-name {
  font-size: 1.15rem;
  margin: 0;
}

small.shop-category {
  color: #9b9ca7;
  margin-bottom: 0.5rem;
}
</style>
